import { FeatureFlagValue, FeatureFlagKeyName, featureDefaults } from '@mobi/settings/featureFlags'

/**
 * dont use this directly, use getFeatureValue instead
 */
export function _returnFeatureValueOrDefault(flagVal: FeatureFlagValue, flag: FeatureFlagKeyName) {
  return typeof flagVal === 'undefined' ? featureDefaults[flag] || false : flagVal
}
